import React, { useCallback } from 'react';
import I18n from 'i18n-js';
import PropTypes from 'prop-types';
import { Button } from 'grab-ui';
import { useSelector } from 'react-redux';

import scribeTrack from 'scribe/scribe-track';
import instrumentationDuck from 'ducks/instrumentation-duck';
import { GRAB_APP_LINK } from 'constants/app-constants';

import styles from './install-app-button.less';

const InstallAppButton = ({ total }) => {
  const { orderId } = useSelector(
    instrumentationDuck.selectors.instrumentation,
  );

  const onInstall = useCallback(
    () => {
      scribeTrack.expressAcquisitionBanner.podDownload({
        orderIdDisplayed: orderId,
        amount: total,
      });

      window.location.href = GRAB_APP_LINK;
    },
    [orderId],
  );

  return (
    <Button data-testid="button" className={styles.button} onClick={onInstall}>
      {I18n.t('installAppButton.button')}
    </Button>
  );
};

InstallAppButton.propTypes = {
  total: PropTypes.string,
};

InstallAppButton.defaultProps = {
  total: '',
};

export default InstallAppButton;
